import clsx, { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const twm = (...classes: ClassValue[]) => twMerge(clsx(...classes))
